import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestLink, StatusType } from 'src/app/request-v2/models/request.model';

interface DialogRow {
    linkedRequestId: string;
    displayId: string;
    title: string;
    currentStatus: StatusType | null;
    selected: boolean;
}

export interface LinkedStatusDialogData {
    newStatus: StatusType;
    eligibleLinks: RequestLink[];
}

@Component({
    selector: 'app-linked-requests-status-dialog',
    templateUrl: './linked-requests-status-dialog.component.html',
    styleUrls: ['./linked-requests-status-dialog.component.scss'],
})
export class LinkedRequestsStatusDialogComponent {
    rows: DialogRow[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: LinkedStatusDialogData,
        private readonly dialogRef: MatDialogRef<LinkedRequestsStatusDialogComponent>,
    ) {
        this.rows = data.eligibleLinks.map((link) => {
            const req = link.linkedRequest;
            const currentStatus = req.category?.statuses?.find((s) => s._id === req.state) || null;
            const title = req.subCategory?.name || req.category?.subCategories?.[0]?.name || req.category?.name || '';
            return {
                linkedRequestId: req._id,
                displayId: req.requestId,
                title,
                currentStatus,
                selected: true,
            };
        });
    }

    get selectedCount(): number {
        return this.rows.filter((r) => r.selected).length;
    }

    toggle(index: number): void {
        this.rows[index].selected = !this.rows[index].selected;
    }

    getStatusBg(color: string): string {
        if (!color) return 'rgba(0,0,0,0.05)';
        const hex = color.replace('#', '');
        const r = Number.parseInt(hex.substring(0, 2), 16);
        const g = Number.parseInt(hex.substring(2, 4), 16);
        const b = Number.parseInt(hex.substring(4, 6), 16);
        return `rgba(${r},${g},${b},0.15)`;
    }

    apply(): void {
        this.dialogRef.close(this.rows.filter((r) => r.selected).map((r) => r.linkedRequestId));
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
